export default __webpack_public_path__ + "static/media/mousee_white.bfef53d3.png";